import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Volví a entrenar después de ser mamá. Y sin pensar qué hacer cada día.',
    author: 'Mariana G.',
    location: 'Córdoba'
  }, {
    quote: 'En 3 semanas ya tenía más energía. El sistema me ordenó la vida.',
    author: 'Laura P.',
    location: 'Rosario'
  }, {
    quote: 'Lo mejor: no tengo que pensar nada. Solo seguir.',
    author: 'Romina M.',
    location: 'Buenos Aires'
  }];
  return <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-302">
      <div className="flex justify-center mb-6" data-id="element-303">
        <div className="bg-brand-card px-6 py-2 rounded-full border border-pink-200" data-id="element-304">
          <span className="text-xl" data-id="element-305">💬</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-306">
        {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-brand-card border border-pink-200 rounded-2xl p-8 shadow-lg relative" data-id="element-307">
            <div className="flex gap-1 mb-6" data-id="element-308">
              {[...Array(5)].map((_, j) => <Star key={j} size={20} className="fill-brand-accent text-brand-accent" data-id="element-309" />)}
            </div>
            <p className="text-lg text-gray-600 mb-8 italic leading-relaxed" data-id="element-310">
              "{testimonial.quote}"
            </p>
            <div className="mt-auto" data-id="element-311">
              <p className="font-bold text-gray-900" data-id="element-312">{testimonial.author}</p>
              <p className="text-sm text-gray-400" data-id="element-313">{testimonial.location}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}